import { render } from "./Movimientos.vue?vue&type=template&id=2737d1f9&scoped=true"
import script from "./Movimientos.vue?vue&type=script&lang=js"
export * from "./Movimientos.vue?vue&type=script&lang=js"

import "./Movimientos.vue?vue&type=style&index=0&id=2737d1f9&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2737d1f9"]])

export default __exports__